import { useState, useCallback } from 'react'
import { searchAPI } from '../api/search.api'
import { Affaire } from '../types/search.types'

export const useDossierSearch = () => {
  const [searchQuery, setSearchQuery] = useState('')
  const [affaire, setAffaire] = useState<Affaire | null>(null)
  const [affaires, setAffaires] = useState<Affaire[]>([])
  const [matchType, setMatchType] = useState<'dossier_id' | 'address' | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const searchDossier = useCallback(async (query: string) => {
    if (!query.trim()) {
      setError('Veuillez saisir un ID d\'affaire ou une adresse')
      return
    }

    try {
      setLoading(true)
      setError(null)
      setAffaire(null)
      setAffaires([])
      setMatchType(null)

      const response = await searchAPI.searchAffaire(query.trim())

      if (response.success) {
        // Handle single result (dossier ID match)
        if (response.data.affaire) {
          setAffaire(response.data.affaire)
          setMatchType(response.data.matchType || 'dossier_id')
        }
        // Handle multiple results (address match)
        else if (response.data.affaires) {
          setAffaires(response.data.affaires)
          setMatchType(response.data.matchType || 'address')
        }
      } else {
        setError(response.message || 'Aucune affaire trouvée')
      }
    } catch (err: any) {
      console.error('Error searching dossier:', err)
      // Extract the error message from the API response if available
      const errorMessage = err?.response?.data?.message || err?.message || 'Erreur lors de la recherche du dossier'
      setError(errorMessage)
    } finally {
      setLoading(false)
    }
  }, [])

  return {
    affaire,
    affaires,
    matchType,
    loading,
    error,
    searchDossier,
    searchQuery,
    setSearchQuery
  }
}